<template>
  <div class="imagery-toggle">
    <button
      type="button"
      :title="imageryOn ? 'Turn off imagery' : 'Show imagery'"
      @click="$emit('toggleImagery')"
    >
      <img
        class="img-src"
        alt="imagery-or-basemap"
        :src="imgSrc"
      >
    </button>
  </div>
</template>

<script>

export default {
  name: 'ImageryToggleControl',
  computed: {
    imgSrc() {
      if (this.imageryOn) {
        return window.location.origin + '/images/basemap_small.png';
      } else {
        return window.location.origin + '/images/imagery_small.png';
      }
    },

    imageryOn () {
      return this.$store.state.map.imageryOn;
    },
  },
}

</script>

<style scoped>

button {
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.imagery-toggle {
  height: 36px;
  width: 36px;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  border-radius: 5px;
  border-style: solid;
  border-width: 2px;
  border-color: rgb(167, 166, 166)
}

.img-src {
  margin-left: -6px;
  margin-top: -1px;
  width: 32px;
  height: 32px;
  max-width: 300%;
  border-radius: 3px;
}

@media 
only screen and (max-width: 760px),
(min-device-width: 768px) and (max-device-width: 1024px)  {

  @supports (-webkit-touch-callout: none) {
    /* CSS specific to iOS devices */ 
    .img-src {
      margin-left: -10px !important;
      width: 36x;
    }
  }
}

</style>